import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FilterFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M21.15 2.8H2.95005C2.45005 2.8 2.05005 3.2 2.05005 3.7V6.4C2.05005 6.6 2.05005 6.7 2.25005 6.9L8.55005 11.6H8.65005C8.95005 12 9.15005 12.4 9.15005 12.8L10.05 20.7C10.05 20.9 10.15 21.1 10.35 21.2C10.35 21.2 10.55 21.2 10.65 21.2C10.75 21.2 10.85 21.2 10.95 21.2L13.55 19.9C13.75 19.9 13.85 19.6 13.85 19.5L14.85 12.8C14.85 12.4 15.15 12 15.45 11.7L21.75 7C21.85 6.9 21.95 6.7 21.95 6.5V3.8C21.95 3.3 21.55 2.9 21.05 2.9L21.15 2.8Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FilterFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FilterFilledIcon;
